
import { Grid } from "@material-ui/core";
import { useStyles } from "./ui/styles"
import FormAlongsideText from "../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText";
import { useMemo } from "react";
import { StyleSwitch } from "../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitch";
import MinumunOrderValue from "../profile/MinumunOrderValue";

export interface IDineInFormState {
  table_enabled: boolean,
  min_dine_in_price: number
}
interface IDineInContainer {
  state: IDineInFormState;
  setState: (state: IDineInFormState) => void
}

export function DineInContainer({ state, setState }: IDineInContainer) {

  const classes: any = useStyles();
  const FormSwitch = useMemo(() => <StyleSwitch onClick={(e) => e.stopPropagation()} defaultChecked={state.table_enabled} onChange={(e: React.ChangeEvent<HTMLInputElement>, value: any) => {
    e.stopPropagation();
    setState({
      ...state,
      table_enabled: value
    })
  }} color="primary" />
    // eslint-disable-next-line
    , [state.table_enabled])

  return (
    <>
      <Grid item xs={12}>
        <FormAlongsideText
          label={"forms.orders.ordertypes"}
        />
      </Grid>
      <Grid item xs={12} className={classes.formSwitchContainer}>
        <FormAlongsideText
          label={"forms.orders.tableService"}
          secondLabel="forms.orders.tableServiceInfo"
        />
        {FormSwitch}
      </Grid>
      <Grid item xs={12} >
        <MinumunOrderValue
          register={undefined!}
          label={""}
          value={state.min_dine_in_price}
          className="DinInMinOrderValue"
          keyName="min_dine_in_price"
          setValue={(_, value: number) => setState({
            ...state,
            min_dine_in_price: value
          })}
          formProps={{
            sideLabel: "forms.orders.dineInMinimum",
            secondLabel: 'forms.orders.dineInMinimumInfo'
          }}
          inputProperties={{

            type: "number",
            placeholder: "£5.00",
            inputProps: { step: 0.01, min: 0 },

          }}
          registerOptions={{ min: 0 }}
        />
      </Grid>
      <>
      </>
    </>
  )
}
